module.exports = "<div class=\"container\">\r\n  <hr>\r\n  <footer>\r\n    <div class=\"row\">\r\n      <div class=\"col-lg-12\">\r\n        <p style=\"color:darkgreen; text-align:center;\">&copy; Gibson Hall, Tulane University • 6823 St Charles Avenue, New Orleans, LA 70118 • 504-865-5261 • provost@tulane.edu</p>\r\n      </div>\r\n    </div>\r\n  </footer>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/footer/footer.component.html
// module id = ./src/app/footer/footer.component.html
// module chunks = main